// extracted by mini-css-extract-plugin
export default {"DeleteContentsDialog":"DeleteContentsDialog_DeleteContentsDialog__34sZs"};